import { createSvgIcon } from '@material-ui/core';

export const DragIcon = createSvgIcon(
  <svg viewBox="0 0 6 19" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0.5H2V2.5H0V0.5ZM4 0.5H6V2.5H4V0.5ZM0 4.5H2V6.5H0V4.5ZM4 4.5H6V6.5H4V4.5ZM0 8.5H2V10.5H0V8.5ZM4 8.5H6V10.5H4V8.5ZM0 12.5H2V14.5H0V12.5ZM4 12.5H6V14.5H4V12.5ZM0 16.5H2V18.5H0V16.5ZM4 16.5H6V18.5H4V16.5Z" />
  </svg>,
  'DragIcon',
);
